import React, {useState} from 'react';
import { makeStyles} from "@material-ui/core/styles";
import Fab from "@material-ui/core/Fab";
import CloseIcon from "@material-ui/icons/Close";
import ForumIcon from "@material-ui/icons/Forum";
import Slide from "@material-ui/core/Slide";
import Conversation from "./components/Conversation";

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    right: 20,
    bottom: 90,
    borderRadius: 8,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    borderLeft: '1px solid #eee',
    maxHeight: 500,
    width: 400,
    boxShadow: '0px 4px 40px rgba(98, 108, 130, 0.15)',
    zIndex: 1000,

    '& .MuiCardHeader-root': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    }
  },
  fab: {
    position: 'fixed',
    right: 20,
    bottom: 20,
    zIndex: 1000,
  },
}));


const Bubble = ({ room }) => {
  const classes = useStyles();
  const [showComments, setShowComments] = useState(false);
  return (
    <>
      <Fab
        color="primary"
        className={classes.fab}
        onClick={() => setShowComments(!showComments)}
      >
        { showComments ? <CloseIcon /> :<ForumIcon />}
      </Fab>
      <Slide timeout={150} direction="up" mountOnEnter in={showComments}>
        <div className={classes.root}>
          <Conversation match={{ params: { roomId: room.id }}} />
        </div>
      </Slide>
    </>
  )
}

export default Bubble;
